<template>
  <v-card>
    <v-card-title class="text-h5 grey lighten-2">
      Edit Details
      <v-spacer> </v-spacer>
      <v-spacer> </v-spacer>
      <v-btn depressed  @click="$emit('closeDialog')" fab x-small icon
        ><v-icon>mdi-close</v-icon></v-btn
      >
    </v-card-title>

    <v-card-text class="mt-4">
      <v-form v-model="valid" ref="form">
        <v-row>
          <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0 required">First Name </label>
            <v-text-field
              :rules="first_nameRules"
              class="rounded"
              v-model="receiver_data.first_name"
              dense
              outlined
              placeholder="First Name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0">Middle Name </label>
            <v-text-field
              class="rounded"
              v-model="receiver_data.middle_name"
              dense
              outlined
              placeholder="Middle Name"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0 required">Last Name</label>
            <v-text-field
              :rules="last_nameRules"
              class="rounded"
              v-model="receiver_data.last_name"
              dense
              outlined
              placeholder="Last Name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0 required">Address</label>
            <v-text-field
              class="rounded"
              dense
              outlined
              v-model="receiver_data.address"
              :rules="addressRule"
              placeholder="Address"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0 required">Mobile Number</label>
            <v-text-field
              placeholder="Enter Mobile Number"
              dense
              class="rounded"
              outlined
              v-model="receiver_data.mobile"
              :rules="contactNumbrules"
              prefix="+60"
              required
              type="number"
              hide-spin-buttons
              :hint="'+60 xx xxx xxxx'"
            ></v-text-field>
          </v-col>
          <!-- <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0 required">DOB</label>
            <v-text-field
              :min="minDate"
              :max="maxDate"
              @change="ValidateAge"
              class="rounded"
              :rules="dobRules"
              dense
              v-model="receiver_data.dob"
              outlined
              type="date"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0 required">Email Id</label>
            <v-text-field
              class="rounded"
              dense
              outlined
              v-model="receiver_data.email"
              :rules="emailRules"
              placeholder="Email Id"
            ></v-text-field>
          </v-col> -->
          <!-- <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0">Location Name</label>
            <v-text-field
              class="rounded"
              dense
              outlined
              v-model="receiver_data.location_name"
              placeholder="Location Name"
            ></v-text-field>
          </v-col> -->
          <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0">Branch Code</label>
            <v-text-field
              class="rounded"
              dense
              outlined
              :rules="branch_code"
              v-model="receiver_data.branch"
              placeholder="Branch"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0 required">Account Number</label>
            <v-text-field
              class="rounded"
              dense
              outlined
              :rules="account_Number"
              v-model="receiver_data.ac_number"
              placeholder="Branch"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0 required">Relationship</label>
            <v-autocomplete
              class="rounded"
              dense
              outlined
              item-text="txt"
              item-value="val"
              :items="relationshipList"
              :rules="relationshipRules"
              v-model="receiver_data.relationship"
              placeholder="Relationship"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn depressed  color="primary" outlined @click="$emit('closeDialog')">
        <v-icon small class="me-2">mdi-close-circle-outline</v-icon>cancel
      </v-btn>
      <v-btn depressed  color="primary" @click="updateRecieverInfo()"> Update </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { validation } from "@/utils/validationCopy.js";
import { findDatePrevious } from "@/utils/helper";
import commonService from "@/services/CommonService/commonService.js";
import PaymentService from "@/services/PaymentService/paymentService.js";
import alerts from "@/mixins/alerts";

export default {
  name: "recieverInfoEdit",
  mixins: [alerts],
  data() {
    return {
      ...validation,
      maxDate: "",
      minDate: "",
      relationshipList: [],
      valid: false,
      isedit: false,
      transaction_id: null,
      receiver_data: {
        receiver_id: null,
        first_name: "",
        middle_name: "",
        last_name: "",
        address: "",
        id_type: null,
        id_number: null,
        email: null,
        dob: null,
        mobile: "",
        user_type: "",
        location_name: "",
        branch: "",
        relationship: null,
        ac_number: "",
      },
    };
  },
  props: {
    recieverInfo: {
      type: Object,
    },
  },
  mounted() {
    this.maxDate = findDatePrevious(new Date(), 18);
    this.minDate = findDatePrevious(new Date(), 70);
    this.mapReceiverData();
    this.getRelationship();
    this.transaction_id = this.$route.query.payment_id
      ? this.$route.query.payment_id
      : null;
  },

  watch: {},
  methods: {
    async getRelationship() {
      try {
        const responseData = await commonService.getRelationships();

        if (responseData.data.status_code === 200) {
          this.relationshipList = responseData.data.data.map((i) => {
            return {
              txt: i.value,
              val: i.value_code,
            };
          });
        } 
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getRelationship();
        // }
        console.log("getRelationship", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async updateRecieverInfo() {
      const validate = this.$refs.form.validate();
      if (validate) {
        try {
          const responseData = await PaymentService.updateReceiverDetails(
            this.receiver_data.receiver_id,
            this.receiver_data
          );
          if (responseData && responseData.data.status_code === 200) {
            // this.$emit("closeDialog");
            this.versionUpdate(responseData.data.data[0].receiver_version_id);
            // this.$emit("RecieverDataUpdated");
            this.showAlertSuccess(responseData.data.message);
          } 
          // else if (responseData.data.status_code === 401) {
          //   this.returnNewToken();
          //   this.profileupdateindivi();
          // } 
          else {
            this.showAlertError(`Failed: ${responseData.data.message}`);
          }
        } catch (e) {
          console.error(e);
        }
      }
      // this.closeStatus();
    },
    mapReceiverData() {
      this.receiver_data = {
        receiver_id: this.recieverInfo.receiver_id,
        first_name: this.recieverInfo.first_name,
        middle_name: this.recieverInfo.middle_name,
        last_name: this.recieverInfo.last_name,
        full_name:this.recieverInfo.full_name,
        address: this.recieverInfo.address,
        id_type: this.recieverInfo.id_type,
        id_number: this.recieverInfo.id_number,
        email: this.recieverInfo.email,
        dob: this.recieverInfo.dob ? this.recieverInfo.dob : null,
        mobile: this.recieverInfo.mobile,
        user_type: this.recieverInfo.user_type,
        location_name: this.recieverInfo.location_name,
        branch: this.recieverInfo.branch,
        relationship: this.recieverInfo.relationship
          ? this.recieverInfo.relationship.value_code
          : null,
        ac_number: this.recieverInfo.ac_number,
      };
    },
    async versionUpdate(id) {
      try {
        const responseData = await PaymentService.updateTxnUpdateVersion({
          transaction_id: this.transaction_id,
          receiver_version_id: id,
        });
        if (responseData && responseData.data.status_code === 200) {
          this.$emit("closeDialog");
          this.$emit("RecieverDataUpdated");
          // this.showAlertSuccess(responseData.data.message);
        } 
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.profileupdateindivi();
        // } 
        else {
          this.showAlertError(`Failed: ${responseData.data.message}`);
        }
      } catch (e) {
        console.error(e);
        this.showAlertError(`Failed: Something went wrong.`);
      }
    },
    ValidateAge(value, e) {
      console.log(value, e);

      if (!value) {
        this.isDobError = false;
      } else {
        this.isDobError = !(value <= this.maxDate && value >= this.minDate);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
</style>
